export default __webpack_public_path__ + "static/2164-679d83697f14efb559eeffe793af05a5.gif";